import { getCookie } from "./cookie-utils";

export const SESSION_INVALID_PHRASES = [
  "your session expired",
  "session expired",
  "api key expired",
  "api key is incorrect",
  "access key is incorrect",
  "authentication failed",
  "invalid session",
];

export function messageIndicatesSessionInvalid(message) {
  const lower = String(message).toLowerCase().trim();
  if (!lower) return false;
  return SESSION_INVALID_PHRASES.some((p) => lower.includes(p));
}

export function responseDataIndicatesSessionInvalid(data) {
  if (typeof data === "string") {
    return messageIndicatesSessionInvalid(data);
  }
  if (data && typeof data === "object") {
    const msg = String(
      data.ErrorMessage ??
        data.errorMessage ??
        data.Message ??
        data.message ??
        "",
    );
    return messageIndicatesSessionInvalid(msg);
  }
  return false;
}

export function shouldSuppressErrorSnackbarForHttpStatus(status) {
  return status === 401;
}

export function hasSessionKeyCookies() {
  const accessKey = getCookie("accessKey");
  const refreshKey = getCookie("refreshKey");
  return (
    !!accessKey &&
    accessKey !== "undefined" &&
    !!refreshKey &&
    refreshKey !== "undefined"
  );
}
